<ion-card class="program-bundle-card" [ngClass]="[selected ? 'selected' : 'not-selected']">
    <div>
        <img class="program-image-bundle" [src]="program?.image | img: program?.state:'md'" />
        <ion-card-title class="program-title ion-text-center">
            {{ program?.offered }}
            <span *ngIf="program?.offered === 1"> Seat offered</span>
            <span *ngIf="program?.offered > 1"> Seats offered</span>
        </ion-card-title>
    </div>
    <form [formGroup]="programBundleForm">
        <section>
            <div class="bundle-name">
                <ion-text color="dark-teal" [routerLink]="['/program/' + program?.id]" routerLinkActive="router-link-active">
                    <p>{{ program?.name }}</p>
                </ion-text>
            </div>
        </section>
        <section>
            <div class="bundle-middle">
                <div class="bundle-location">
                    <fa-icon [icon]="icons.pin" class="location-pin"></fa-icon>
                    {{ program?.city }}, {{ program?.state }}
                </div>
                <div class="bundle-price">
                    <p class="bundle-price-number">${{ program?.price }} <span>USD</span></p>
                </div>
            </div>
        </section>
        <section class="tag-section">
            <div lines="none" class="tag-container">
                <ion-chip *ngFor="let tags of program?.programtags" class="bundle-chip">
                    {{ tags }}
                </ion-chip>
            </div>
        </section>
        <section class="ion-text-center button-section">
            <ion-button class="learn-more-button" (click)="openDetails($event)" color="secondary" expand="block" fill="solid" shape="round">
                Learn more about this experience
            </ion-button>
        </section>
        <section>
            <ion-list lines="none">
                <ion-item>
                    <ion-label>Add to my bundle</ion-label>
                    <ion-toggle slot="start" (ionChange)="changeToForm($event)" formControlName="selected" [disabled]="programNotAvail"></ion-toggle>
                </ion-item>
            </ion-list>
        </section>
        <section>
            <div class="bundle-duration-container">
                <ion-text color="primary">
                    <p class="duration-text">Duration: 4 weeks</p>
                </ion-text>
            </div>
        </section>
        <section class="ion-margin-bottom">
            <ion-list>
                <ion-item lines="none" (click)="openProgramModal('type')">
                    <ion-label position="stacked" color="dark-teal">Type</ion-label>
                    <ion-input
                        [attr.id]="'selectTypeBundleIndex' + index"
                        placeholder="Select a rotation type"
                        readonly
                        class="apply-select"
                        [value]="programType"
                        formControlName="type"
                        [disabled]="types.length <= 1 || programNotAvail || checkedDisabled"
                        placeholder="Select a rotation type"
                        (ionChange)="changeToForm($event)"
                    ></ion-input>
                    <!-- <ion-select
                        [attr.id]="'selectTypeBundleIndex' + index"
                        [interfaceOptions]="selectOptions"
                        [disabled]="
                            types.length <= 1 ||
                            programNotAvail ||
                            checkedDisabled
                        "
                        (ionChange)="changeToForm($event)"
                        formControlName="type"
                        [interface]="selectionMode"
                        placeholder="Select a rotation type"
                    >
                        <ion-select-option
                            *ngFor="let type of types"
                            [value]="type"
                            >{{ type }}</ion-select-option
                        >
                    </ion-select> -->
                </ion-item>
                <ion-item lines="none" (click)="openProgramModal('time')">
                    <ion-label position="stacked" color="dark-teal">Start date</ion-label>
                    <ion-input
                        placeholder="Select a rotation start date"
                        readonly
                        class="apply-select"
                        [value]="programTime"
                        formControlName="start"
                        style="display: none"
                    ></ion-input>
                    <ion-input
                        placeholder="Select a rotation start date"
                        readonly
                        class="apply-select"
                        [value]="programTime?.display"
                        [attr.id]="'selectTimeBundleIndex' + index"
                        [disabled]="programNotAvail || checkedDisabled"
                        (ionChange)="changeToForm($event)"
                    ></ion-input>

                    <!-- {{programTime | json}} -->
                    <!-- id="programTime?.startdate" -->

                    <!-- <ion-select
                        [interfaceOptions]="selectOptions"
                        [interface]="selectionMode"
                        [disabled]="programNotAvail || checkedDisabled"
                        (ionChange)="changeToForm($event)"
                        formControlName="start"
                        placeholder="Select a start date"
                        [attr.id]="'selectTimeBundleIndex' + index"
                    >
                        <ion-select-option
                            *ngFor="let time of rows"
                            [value]="time"
                            >{{ time?.display }}</ion-select-option
                        >
                    </ion-select> -->
                </ion-item>
                <div *ngIf="programNotAvail" class="ion-text-center program-noavail-text">
                    <ion-label class="no-aval-text"><small>Program unavailable</small></ion-label>
                </div>
            </ion-list>
        </section>
    </form>
</ion-card>
